import React, { useEffect, useState } from "react";
import axios from "axios";
import { useParams } from "react-router";
import { Tabs, Tab } from "react-bootstrap";
import AddressDetails from "./AddressDetails";
import PaymentDetails from "./PaymentDetails";
import PersonalDetails from "./PersonalDetails";
import Loading from '../../../../utilities/Loading'

export default function ViewUser() {
  const { id } = useParams();
  const [user, setUser] = useState({});
  const [loaded, setLoaded] = useState(false);
  const fetchUserById = async (id) => {
    const { data } = await axios.get(`/api/users/${id}`);
    setUser(data);
    setLoaded(true);
  };
  useEffect(() => {
    fetchUserById(id);
  }, [id]);

  return (
    <div className="wrapper wrapper-content">
      {
        loaded ? (
          <Tabs defaultActiveKey="personal">
            <Tab eventKey="personal" title="Personal Details">
              <PersonalDetails user={user} />
            </Tab>
            <Tab eventKey="address" title="Address Details">
              <AddressDetails address={user.addresses} />
            </Tab>
            <Tab eventKey="payment" title="Payment Details">
              <PaymentDetails cards={user.cards} />
            </Tab>
          </Tabs>
        ) : <Loading />
      }
    </div>
  )
}
